import React, { useEffect, useState } from 'react'
import rightArrow from '../../assets/right-arrow.svg'
import DashboardIcon1 from '../../assets/dashboard-1.svg'
import DashboardIcon2 from '../../assets/dashboard-2.svg'
import DashboardIcon3 from '../../assets/dashboard-3.svg'
import DashboardIcon4 from '../../assets/dashboard-4.svg'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import IsLoadingHOC from '../HOC/loader/IsLoadingHOC'
import _ from "lodash";
import $ from "jquery";
import { addOldAccount, getDisoveryAccount, onAddCreator, onCheckAccounts, onCheckSocialAccounts, onCheckUserProfile, onCheckValidateCreator, onGetLinkedAccount } from '../../services'
import { onGetProfileDetails, onJustReducerUpdate } from '../../redux/action'
import { CREACTOR_DETAILS, HANDLE_IS_FIRST_TIME, IS_NEW_COMER, LINKED_PERSONAL_DATA, PROFILE_DETAILS, REGISTER_DETAILS } from '../../redux/action_type'
import { useToast } from '../../toast'
import { isValidUrl, truncate } from '../../utils/common'
import Close_black from "../../assets/close_black.svg";
import instaLinkImg from "../../assets/instagram-link.svg";
import Select, { components } from 'react-select';
import socialIcon1 from "../../assets/insta-icon.svg";
import socialIcon2 from "../../assets/facebook-icon.svg";
import socialIcon3 from "../../assets/youtube-icon.svg";
import socialIcon4 from "../../assets/twitter-icon.svg";
import whiteCross from "../../assets/images/white-cross.svg";
import pinMark from "../../assets/pin-mark.svg";

function Dashboard(props) {
    const profileDetails = useSelector((state) => state.profileDetails)
    const profileDetailsLoading = useSelector((state) => state.profileDetailsLoading)
    const isNewComer = useSelector((state) => state.isNewComer)
    const [selectedOption, setSelectedOption] = useState({ value: 'instagram', label: 'Instagram' });
    const [channelName, setChannelName] = useState("");
    const loginDetails = useSelector((state) => state.loginDetails)

    const prefix = '@'
    const { Option } = components;
    const { setLoading } = props;
    const dispatch = useDispatch()
    const history = useHistory();
    const toast = useToast();
    let authData = localStorage.getItem(REGISTER_DETAILS)
    authData = JSON.parse(authData)
    const socialMediaOptions = [
        { value: 'instagram', label: 'Instagram', icon: socialIcon1 },
        { value: 'facebook', label: 'Facebook', icon: socialIcon2 },
        { value: 'youtube', label: 'Youtube', icon: socialIcon3 },
    ]
    const handleChange = (e) => {
        setSelectedOption(e);
    };
    const onValueChange = (value) => {
        setChannelName(value)
    }
    const IconOption = props => {
        return (
            <Option {...props} className="select-option">
                <img
                    className='drop-down-img'
                    src={props?.data?.icon}
                    style={{ width: 36 }}
                    alt={props.data.label}
                />
                {props.data.label}
            </Option>
        )
    };
    useEffect(() => {
        setLoading(profileDetailsLoading)
        return () => dispatch(onJustReducerUpdate(false, IS_NEW_COMER))
    }, [profileDetailsLoading])
    useEffect(() => {
        if (loginDetails?.is_insert) {
            $("#name-update-popup").modal("show")
            dispatch(onJustReducerUpdate(loginDetails?.is_insert, HANDLE_IS_FIRST_TIME))
            dispatch(onJustReducerUpdate({}, REGISTER_DETAILS))
        }
    }, [loginDetails])
    useEffect(() => {
        if (profileDetailsLoading || _.isEmpty(profileDetails)) {
            return
        }
        // if (profileDetails?.cp_creators?.length === 0 || !profileDetails?.cp_creators?.length && !profileDetailsLoading) {
        //     history.push("/link-account");
        // } else if (!profileDetailsLoading) {
        history.push("/dashboards");
        onGetLinkedAccount().then((res) => {
            if (res.status) {
                dispatch(onJustReducerUpdate(res?.data, LINKED_PERSONAL_DATA))
                getDisoveryAccount((response) => {
                    console.log("123getDisoveryAccountresponse", response)
                })
            }
        }).catch((err) => console.log("err", err))
        // }
    }, [profileDetails, profileDetailsLoading])

    const handleKeyPress = (e) => {
        if (e.keyCode === 13 && e.target.value != "") {
            onCheck()
        }
    }

    const onCheck = () => {
        let contructChannelName = channelName.split("/")?.filter(n => n)?.slice(-1).pop()
        if (!contructChannelName || !profileDetails?.name || !selectedOption?.value) {
            toast.open("Please add the profile name", "warn")
            console.log("please check the values")
            return
        }
        setLoading(true)
        contructChannelName = contructChannelName.split("@")?.slice(-1).pop()
        let payload = {
            "publisher_name": profileDetails?.name,
            "network": selectedOption?.value,
            "userid": contructChannelName
        }
        onCheckValidateCreator(payload).then((res) => {
            if (res.status) {
                const validateResponse = res.data
                if (validateResponse.new_status && validateResponse.is_delete) {
                    payload = { ...payload, is_delete: true, publisher_id: validateResponse.publisher_id, socialNetworkId: validateResponse?.socialNetworkId }
                    onAddCreator(payload).then((response) => {
                        setLoading(false)
                        $("#link-account-popup-1").modal("hide");
                        setSelectedOption([])
                        setChannelName("")
                        if (response.status) {
                            toast.open("Account added successfully")
                            dispatch(onJustReducerUpdate(response.data, CREACTOR_DETAILS))
                            history.push("/account-authentication")
                        }
                    }).catch((e) => setLoading(false))
                } else if (validateResponse.new_status && !validateResponse.is_delete) {
                    payload = { ...payload, is_delete: false, publisher_id: 0, socialNetworkId: validateResponse?.socialNetworkId }
                    onAddCreator(payload).then((response) => {
                        setLoading(false)
                        $("#link-account-popup-1").modal("hide");
                        setSelectedOption([])
                        setChannelName("")
                        if (response.status) {
                            toast.open("Account added successfully")
                            dispatch(onJustReducerUpdate(response.data, CREACTOR_DETAILS))
                            history.push("/account-authentication")
                        }
                    }).catch((e) => setLoading(false))
                } else if (validateResponse.error) {
                    setLoading(false)
                    toast.open(res?.message, "error")
                    $("#link-account-popup-1").modal("hide");
                    setSelectedOption([])
                    setChannelName("")
                }
            } else {
                setLoading(false)
                toast.open(res?.message, "error")
            }
        }).catch((err) => {
            setLoading(false)
            console.log("err", err)
        })
    }
    // useEffect(()=>{
    //     if (profileDetailsLoading || _.isEmpty(profileDetails)) {
    //         return
    //     }
    //     onGetLinkedAccount().then((res) => {
    //         if (res.status) {
    //             console.log("123res12", authData.josh_user_id)
    //             onCheckUserProfile(authData.josh_user_id).then(response=>{
    //             console.log("123response12", response)
    //                 dispatch(onJustReducerUpdate(response.data, PROFILE_DETAILS))
    //             })
    //         }
    //     }).catch((err) => console.log("err", err))
    // },[])

    useEffect(() => {
        if (!_.isEmpty(profileDetails)) {
            if (!_.isEmpty(profileDetails?.cp_creators)) {
                const { is_linked } = profileDetails?.cp_creators?.[0]
                if (is_linked) {
                    return
                }
            }
            onCheckLinkValue()
        }
    }, [profileDetails])

    useEffect(() => {
        if (typeof window?.newsHuntAction != 'undefined' && typeof window?.newsHuntAction.isLoggedIn != 'undefined') {
            const isLoggedIn = window?.newsHuntAction?.isLoggedIn()
            console.log("123isLoggedIndas", isLoggedIn)
            if (!isLoggedIn) {
                console.log("123isLoggedIndasIn")
                localStorage.removeItem(REGISTER_DETAILS)
                dispatch(onJustReducerUpdate({}, PROFILE_DETAILS))
                history.push("/")
                return
            }
        }
        const search = window.location.search;
        const params = new URLSearchParams(search);
        const getEdit = params.get('act');
        if (getEdit === "edit-profile") {
            $('.edit-profile').modal("show")
        } else if (getEdit === "about-us") {
            $('#aboutus-modal').modal("show")
        } else if (getEdit === "help") {
            window.location.href = `mailto:${process.env.REACT_APP_HELP_MAIL}?body=${window.location.origin}`;
        } else if (getEdit === "logout") {
            $('#logout-popup').modal("show")
        } else if (getEdit === "creator-detail") {
            $('#creator-pop-new').modal("show")
        }
    }, [])

    const onCheckLinkValue = () => {
        if (!_.isEmpty(profileDetails?.cp_creators)) {
            const { login_network, publisher_id, is_linked } = profileDetails?.cp_creators?.[0]
            const payload = {
                "network": login_network,
                "publisher_id": publisher_id
            }
            if (is_linked) {
                return
            }
            onCheckAccounts(payload).then((res) => {
                console.log("123res", res)
                if (!res.data.linked) {
                    addOldAccount({ publisher_id, is_deleted: true }).then(responseData => {
                        if (responseData.status) {
                            dispatch(onGetProfileDetails(authData.josh_user_id))
                        }
                    }).catch(err => console.log("err3", err))
                }
            })
        }
    }

    const onClickSocial = () => {
        if (!profileDetails?.cp_creators?.[0]?.publisher_id) {
            return
        }
        if (profileDetails.name.includes("guest")) {
            $("#name-update-popup").modal("show")
            return
        }
        history.push("/social-performance")
    }
    const onClickCampaign = (async () => {
        const response = await onCheckSocialAccounts()
        if (!response.status) {
            toast.open("Please link at least one account", "", true, () => history.push("/account-authentication"), "Go to link account")
            return
        }
        if (!profileDetails?.cp_creators?.[0]?.dashboard_link) {
            return
        }
        window.open(`${profileDetails?.cp_creators?.[0]?.dashboard_link}`, 'popUpWindow', 'height=800,width=1500,left=100,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes');
    })

    if (profileDetailsLoading) {
        return
    }

    const onClickAffliate = () => {
        const unloadCallback = (event) => {
            event.preventDefault();
              return null
          };
          if (profileDetails?.cp_creator_domains?.length > 0) {
              window.open(process.env.REACT_APP_NAVIGATE_URL,"_blank")
            } else {
                window.open(process.env.REACT_APP_NAVIGATE_URL,"_blank");
            }
            return () => window.removeEventListener("beforeunload", unloadCallback);
    }

    const onUpdateName = () => {
        $("#name-update-popup").modal("hide")
    }
    const onHandleRedirect = (trueFn) => {
        if (profileDetails?.cp_creators?.length === 0 || !profileDetails?.cp_creators?.length) {
            $("#link-account-popup-1").modal("show");
        } else {
            trueFn()
        }
    }
    return (
        <>
            <div
                className="modal fade logout-popup-wrap session-popup"
                id="name-update-popup"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                data-backdrop="static"
                data-keyboard="false"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered custom-popup " role="document">
                    <div className="modal-content   ">
                        <div className="modal-body pt-0 mt-3">
                            <div className='logout-card'>
                                <p>Since you've Signed In through a mobile number and OTP, we strongly recommend you set a valid user name initially.
                                    It is important because the user name will eventually be used in your social performance report.</p>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className='common-btn'>
                                <button className='bg-btn' data-toggle="modal" data-dismiss="modal" data-target="#edit-profile">Ok</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='middle-content-wrap'>
                <div className='dashboard-wrap'>
                    <h2>Welcome, <span>{truncate(`${profileDetails?.name || ""}`, 30)}!</span></h2>
                    <div className='row'>
                        <div className='col-md-6'>
                            <a onClick={() => onHandleRedirect(() => history.push("/account-authentication"))}>    <div className='dashboard-card hover-card-left'>
                                <img className='dashboard-logo' src={DashboardIcon3} alt="" />
                                <img className='right-arrow-btn' src={rightArrow} alt="" />
                                <p>Link Accounts</p>
                                <span>Connect more accounts and monitor your performance</span>
                            </div></a>

                        </div>
                        <div className='col-md-6'>
                            <a onClick={onClickAffliate}>  <div className='dashboard-card hover-card-right'>
                                {/* <div className='comming-soon-text'>
                                    Coming Soon
                                </div> */}
                                <img className='dashboard-logo' src={DashboardIcon4} alt="" />
                                <img className='right-arrow-btn' src={rightArrow} alt="" />
                                <p>Creator's Affiliate Store</p>
                                <span>Choose from</span>
                                <span className="brandsCount"> 20000+ affiliate products</span>
                            </div></a>
                        </div>
                        <div className='col-md-6'>
                            <a onClick={() => onHandleRedirect(onClickCampaign)}><div className='dashboard-card hover-card-left'>
                                <img className='dashboard-logo' src={DashboardIcon2} alt="" />
                                <img className='right-arrow-btn' src={rightArrow} alt="" />
                                <p>Collaboration Invites</p>
                                <span className="brandsCount">10000+ brands</span>
                                <span className="descTitle"> are waiting for collaborations</span>
                            </div> </a>

                        </div>
                        <div className='col-md-6'>
                            <a onClick={() => onHandleRedirect(onClickSocial)}>  <div className='dashboard-card hover-card-right'>
                                <img className='dashboard-logo' src={DashboardIcon1} alt="" />
                                <img className='right-arrow-btn' src={rightArrow} alt="" />
                                <p>Media kit and Social Insights</p>
                                <span className="brandsCount">45+ performance</span>
                                <span className="descTitle"> metrics tracked in one place</span>
                            </div> </a>

                        </div>
                    </div>
                </div>
            </div>


            <div
                className="modal fade logout-popup-wrap link-account-popup"
                id="link-account-popup-1"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                data-backdrop="static"
                data-keyboard="false"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered custom-popup " role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">
                                Link Account
                            </h5>
                            <button type="button" className="close" data-dismiss="modal">
                                <span aria-hidden="true">
                                    <img className="closeModal" src={Close_black} alt="" />
                                </span>
                            </button>
                        </div>
                        <div className="modal-body ">
                            <div className='link-account-popup-wrap'>
                                <img src={instaLinkImg} alt="" />
                                <p>Add your primary social account handle for brand campaigns</p>
                                <div className='link-account-options'>
                                    <div className='form-group'>
                                        <Select
                                            className="basic-single"
                                            classNamePrefix="select"
                                            isClearable={false}
                                            isSearchable={false}
                                            options={socialMediaOptions}
                                            name="color"
                                            onChange={handleChange}
                                            value={selectedOption}
                                            components={{ Option: IconOption }}
                                            formatOptionLabel={data => {
                                                return (
                                                    <div className="country-option">
                                                        <img
                                                            className='drop-down-img-label'
                                                            src={data.value === "instagram" ? socialIcon1 : data.value === "facebook" ? socialIcon2 : data.value === "youtube" ? socialIcon3 : socialIcon4}
                                                            style={{ width: 36 }}
                                                            alt={data.label}
                                                        />
                                                    </div>
                                                )
                                            }}
                                        />
                                        <input
                                            type="text"
                                            className="form-control"
                                            onKeyDown={handleKeyPress}
                                            onChange={(e) => {
                                                const input = e.target.value
                                                if (isValidUrl(input)) {
                                                    e.target.value = input
                                                } else {
                                                    setChannelName((prev) => {
                                                        if (prev.length === 0) {
                                                            e.target.value = prefix + input
                                                        } else {
                                                            e.target.value = prefix
                                                            if (input.length > 0) {
                                                                e.target.value = prefix + input.substr(prefix.length)
                                                            } else {
                                                                e.target.value = ""
                                                            }
                                                        }
                                                        onValueChange(e.target.value)
                                                        return
                                                    })
                                                }
                                                onValueChange(e.target.value)
                                            }}
                                            value={channelName}
                                            placeholder={`Enter your user handle or username`}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className='common-btn'>
                                <button type='button' className={`${!channelName ? "link-btn-disabled" : ""}`} disabled={!channelName} onClick={onCheck}><img src={pinMark} alt="" /> Link Account</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isNewComer && <div className='additional-bar'>
                <p>Add additional information to help brands know you better and increase your chances for getting shortlisted for campaign
                </p> <button className='common-btn' onClick={() => {
                    dispatch(onJustReducerUpdate(false, IS_NEW_COMER))
                    $("#creator-pop-new").modal("show")
                }}>ADD</button>
                <img src={whiteCross} alt="" onClick={() => {
                    dispatch(onJustReducerUpdate(false, IS_NEW_COMER))
                    $("#creator-pop-new").modal("hide");
                }} />
            </div>}
        </>
    )
}

export default IsLoadingHOC(Dashboard)